// extracted by mini-css-extract-plugin
export default {"container":"mW-z","title":"nW-z","link":"oW-z"};